/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_TaxCertificationW9Forms } from '../models/PagedResultDto_TaxCertificationW9Forms';
import type { Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW8DTO } from '../models/Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW8DTO';
import type { Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW9DTO } from '../models/Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW9DTO';
import type { Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationListViewDTO } from '../models/Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationListViewDTO';
import type { Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationViewDTO } from '../models/Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationViewDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TaxCertificationService {

    /**
     * @param formData
     * @returns Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW9DTO OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppTaxCertificationTaxCertificationFormW9(
        formData?: {
            Name: string;
            BusinessName?: string;
            IndividualProprietor: boolean;
            CCorporation: boolean;
            SCorporation: boolean;
            Partnership: boolean;
            Trust: boolean;
            LimitedLiabilityCompany: boolean;
            LimitedLiabilityCompanyText?: string;
            FederalTaxClassificationOther: boolean;
            FederalTaxClassificationOtherText?: string;
            Address: string;
            CityStateZipCode: string;
            AccountNumbers?: string;
            ExcemptPayeeCode?: string;
            ExcemptionFATCAReportingCode?: string;
            RequestorName?: string;
            RequestorAddress?: string;
            SSN: string;
            EmployerIdenticationNumber?: string;
            CertificationDate: string;
            Signature: Blob;
        },
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW9DTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/tax-certification/tax-certification-form-w9',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData
     * @returns Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW9DTO OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppTaxCertificationTaxCertificationFormW9(
        formData?: {
            Name: string;
            BusinessName?: string;
            IndividualProprietor: boolean;
            CCorporation: boolean;
            SCorporation: boolean;
            Partnership: boolean;
            Trust: boolean;
            LimitedLiabilityCompany: boolean;
            LimitedLiabilityCompanyText?: string;
            FederalTaxClassificationOther: boolean;
            FederalTaxClassificationOtherText?: string;
            Address: string;
            CityStateZipCode: string;
            AccountNumbers?: string;
            ExcemptPayeeCode?: string;
            ExcemptionFATCAReportingCode?: string;
            RequestorName?: string;
            RequestorAddress?: string;
            SSN: string;
            EmployerIdenticationNumber?: string;
            CertificationDate: string;
            Signature: Blob;
        },
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW9DTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/tax-certification/tax-certification-form-w9',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationViewDTO OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTaxCertificationLatestTaxCertificationForm(): CancelablePromise<Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationViewDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/tax-certification/latest-tax-certification-form',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId
     * @returns Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationViewDTO OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTaxCertificationTaxCertificationForm(
        participantId: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationViewDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/tax-certification/tax-certification-form/{ParticipantId}',
            path: {
                'ParticipantId': participantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param fromCertificationDate
     * @param toCertificationDate
     * @param fromExpirationDate
     * @param toExpirationDate
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_TaxCertificationW9Forms OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTaxCertificationTaxCertificationFormW9List(
        fromCertificationDate?: string,
        toCertificationDate?: string,
        fromExpirationDate?: string,
        toExpirationDate?: string,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_TaxCertificationW9Forms> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/tax-certification/tax-certification-form-w9List',
            query: {
                'FromCertificationDate': fromCertificationDate,
                'ToCertificationDate': toCertificationDate,
                'FromExpirationDate': fromExpirationDate,
                'ToExpirationDate': toExpirationDate,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData
     * @returns Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW8DTO OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppTaxCertificationTaxCertificationFormW8(
        formData?: {
            Name: string;
            CitizenshipCountryId: string;
            PermanentAddress: string;
            PermanentCity: string;
            PermanentCountryId: string;
            HasDifferentMailingAddress: boolean;
            MailingAddress?: string;
            MailingCity?: string;
            MailingCountryId?: string;
            SSNOrIdentificationNumber?: string;
            ForeignTaxIdentifyingNumber?: string;
            FTINLegallyRequired: boolean;
            ReferenceNumber?: string;
            DateOfBirth: string;
            BeneficialCountryId: string;
            BeneficialArticle?: string;
            BeneficialPercentage?: string;
            BeneficialIncomeType?: string;
            BeneficialAdditionalCondition?: string;
            CapacitySignCertify: boolean;
            CertificationDate: string;
            PrintName: string;
            Signature: Blob;
        },
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCertificationFormW8DTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/tax-certification/tax-certification-form-w8',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationListViewDTO OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTaxCertificationTaxCertificationFormList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationListViewDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/tax-certification/tax-certification-form-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taxCertificationId
     * @param type
     * @returns Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationViewDTO OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTaxCertificationTaxCertificationFormById(
        taxCertificationId: string,
        type?: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationViewDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/tax-certification/tax-certification-form-by-id/{taxCertificationId}',
            path: {
                'taxCertificationId': taxCertificationId,
            },
            query: {
                'type': type,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taxCertificationId
     * @returns string OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTaxCertificationTaxCertificationW8Ssn(
        taxCertificationId: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/tax-certification/tax-certification-w8SSN/{taxCertificationId}',
            path: {
                'taxCertificationId': taxCertificationId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param taxCertificationId
     * @returns string OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTaxCertificationTaxCertificationW9Ssn(
        taxCertificationId: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/tax-certification/tax-certification-w9SSN/{taxCertificationId}',
            path: {
                'taxCertificationId': taxCertificationId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTaxCertificationW8SsnForParticipant(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/tax-certification/w8SSNFor-participant',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppTaxCertificationW9SsnForParticipant(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/tax-certification/w9SSNFor-participant',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
